module.exports = __webpack_public_path__ + "img/almenu_gomb_kutatasok_tudasbazis_aktiv.6bfebde1.png";